module.exports = __webpack_public_path__ + "static/img/MZGH2.a2408b9c.png";